module.exports = __webpack_public_path__ + "img/title0.d3ed5357.png";